import styled from 'styled-components';
import { skeletonAnimation } from './Skeletons';

type Props = {
  height?: string;
  width?: string;
  marginTop?: string;
};

export const TitleSkeletonLoader = styled.div<Props>`
  height: ${({ height }) => height ?? '1.75rem'};
  width: ${({ width }) => width ?? '40%'};
  margin-top: ${({ marginTop }) => marginTop ?? '0.375rem;'};
  ${skeletonAnimation}
`;

export const ParagraphSkeletonLoader = styled.div<Props>`
  height: ${({ height }) => height ?? '1rem'};
  width: ${({ width }) => width ?? '40%'};
  margin-top: ${({ marginTop }) => marginTop ?? '0.375rem;'};
  ${skeletonAnimation}
`;
